



















import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";

interface DropdownItem {
  key: string;
  name: string;
  path: string;
}

const pathPattern = /\/projects\/.*?\/(.*)$/i;

@Component({})
export default class VProjectDropdown extends Vue {
  @Prop({ default: () => [] }) projects!: Project[];

  get items(): DropdownItem[] {
    return this.projects.map(p => ({
      key: String(p.projectId),
      name: p.name,
      path: this.createPath(p)
    }));
  }

  createPath(p: Project): string {
    if (pathPattern.test(this.$route.path)) {
      const child = this.$route.path.replace(pathPattern, "$1");
      return `/projects/${p.projectId}/${child}`;
    }
    return `/projects/${p.projectId}`;
  }
}
